import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import { httpAdminApi } from './api/client.ts';
import '@bb/ui/styles.css';
import './styles.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App api={httpAdminApi} />
  </StrictMode>,
);
